export default "__VITE_ASSET__415ac56e__"